import { gql } from '@apollo/client';

export const COURSE_QUERY = gql`
    query course($courseID: UUID!) {
        course(courseID: $courseID) {
            node {
                id
                courseCertificates {
                    id
                    courseId
                    certificateTemplate {
                        id
                        name
                    }
                    brand {
                        id
                        name
                        slug
                        segmentId
                        weight
                    }
                    createdAt
                    updatedAt
                  }
                locales {
                    locale
                    name
                    description
                }
                thumbnailImage {
                    id
                    name
                    url
                    __typename
                }
                heroImage {
                    id
                    name
                    url
                    __typename
                }
                tags
                tagIds
                points
                isPublic
                isSequential
                enrollmentCount
                learningObjects {
                    edges {
                        assignment {
                            status
                            scormState
                            __typename
                        }
                        node {
                            id
                            locales {
                                locale
                                name
                                description
                            }
                            duration
                            content {
                                id
                                url
                                __typename
                            }
                            __typename
                        }
                        __typename
                    }
                    __typename
                }
                prerequisiteSet {
                    id
                    objectId
                    operator
                    type
                    prerequisites {
                        objectId
                        weight
                    }
                }
                prerequisiteStatus { 
                    isPrerequisiteOf
                    hasPrerequisites
                }
                isFeatured
                weight
                categoryIds
                segmentIds
                brandIds
                productIds
                localeIds
                learningProfileIds
                resourceIds
                companyRelationshipIds
                employeeLocaleIds
                metadata
                createdAt
                updatedAt
                __typename
            }
            __typename
        }
    }
`;
